// useMapboxGeocoder.js
import React from "react";
import axios from "axios";
import debounce from "debounce-fn";
import { MAPBOX_API_KEY } from "../utils/mapbox-api-key";
const baseUrl = `https://api.mapbox.com/geocoding/v5/mapbox.places`
const initialState = {
  isLoading: false,
  error: false,
  data: [],
};
const actionTypes = {
  FETCH_REQUEST: "FETCH_REQUEST",
  FETCH_SUCCESS: "FETCH_SUCCESS",
  FETCH_FAILURE: "FETCH_FAILURE",
};
function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_REQUEST:
      return { ...state, isLoading: true };
    case actionTypes.FETCH_SUCCESS:
      return {
        ...state,
        error: false,
        isLoading: false,
        data: action.results,
      };
    case actionTypes.FETCH_FAILURE:
      return { ...state, isLoading: false, error: true };
    default:
      return state;
  }
}
export function useMapboxGeocoder() {
  const [{ isLoading, error, data }, dispatch] = React.useReducer(
    reducer,
    initialState,
  );
  const fetchMapboxResults = debounce(
    async searchString => {
      const mapboxUrl = `${baseUrl}/${encodeURIComponent(searchString)}.json`;
      dispatch({ type: actionTypes.FETCH_REQUEST });
      try {
        const response = await axios.get(mapboxUrl, {
          params: {
            access_token: MAPBOX_API_KEY,
            country: 'au',
            bbox: '139.965,-38.03,155.258,-27.839',
            language: 'en-AU'
          }
        });
        dispatch({
          type: actionTypes.FETCH_SUCCESS,
          results: response.data.features.filter(feature => {
            // returns true if item contains New South Wales region
            return feature.context.some((i) => {
              // ID is in the form {index}.{id} per https://github.com/mapbox/carmen/blob/master/carmen-geojson.md
              // This example searches for the `region`
              // named `New South Wales`.
              return (
                i.id.split('.').shift() === 'region' &&
                i.text === 'New South Wales'
              );
            });
          }).map(feature => ({
            ...feature,
            properties: {
              ...feature.properties,
              _path: 'poi/'+feature.id,
              title: feature.text,
              address: feature.place_name
            }
          })),
        });
      } catch (error) {
        dispatch({ type: actionTypes.FETCH_FAILURE, error });
      }
    },
    { wait: 300 },
  );
  return { error, isLoading, data, fetchMapboxResults };
}